import React from "react";

const DirtyContext = React.createContext({
  isDirty: false,
  setDirty: () => {},
  confirmLeave: () => true,
});

export const DirtyProvider = ({ children }) => {
  const [isDirty, setIsDirty] = React.useState(false);

  const setDirty = React.useCallback((value) => {
    setIsDirty(Boolean(value));
  }, []);

  const confirmLeave = React.useCallback(() => {
    if (!isDirty) return true;
    return window.confirm(
      "Tienes cambios sin guardar. ¿Quieres salir y descartarlos?"
    );
  }, [isDirty]);

  return (
    <DirtyContext.Provider value={{ isDirty, setDirty, confirmLeave }}>
      {children}
    </DirtyContext.Provider>
  );
};

export const useDirty = () => React.useContext(DirtyContext);
